;(function () {
  'use strict';

  /**
   * プロフィール設定モーダル
   */
  var profileModal = {
    /**
     * 初期化
     */
    init: function (options) {
      var config = $.extend({
        dialog: '.ui-dialog--profile',            // ダイアログのセレクタ
        sideMargin: 15,                           // 左右の余白 [px]
        openButton: '.js-dialog--profile__open',  // ダイアログの表示ボタン
        closeButton: '.js-dialog--profile__close' // ダイアログの非表示ボタン
      }, options);

      if ($('body.sp-viewport').length) {
        // sp版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargin * 2),
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-profile',
          show: 'fade',
          hide: 'fast'
        });
      } else {
        // pc版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: 800,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-profile',
          show: 'fade',
          hide: 'fast'
        });
      }

      /**
       * ログインモーダル 表示イベント
       */
      $(config.openButton).on('click', function () {
        $(config.dialog).dialog('open');
        return false;
      });

      /**
       * ログインモーダル 非表示イベント
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });

      // ダイアログ以外の場所をタップしたらダイアログが消える
      $(document).on('click', '.ui-widget-overlay', function () {
        $(this).prev().find('.ui-dialog-content').dialog('close');
        // ダイアログが消えたら、スクロール可能に
        $(window).off('.noScroll');
      });
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    profileModal.init();
  });
}.call(this));
